/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DeleteElevatedUserResponse } from '../../models/delete-elevated-user-response';

export interface DeleteElevatedUser$Params {
  elevatedId: string;
}

export function deleteElevatedUser(http: HttpClient, rootUrl: string, params: DeleteElevatedUser$Params, context?: HttpContext): Observable<StrictHttpResponse<DeleteElevatedUserResponse>> {
  const rb = new RequestBuilder(rootUrl, deleteElevatedUser.PATH, 'delete');
  if (params) {
    rb.path('elevatedId', params.elevatedId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DeleteElevatedUserResponse>;
    })
  );
}

deleteElevatedUser.PATH = '/api/v2/elevatedUsers/{elevatedId}';
